import React from "react";

import Dialog from "@material-ui/core/Dialog";

import "./index.scss";
import DupontButton from "../DupontButton";
import { OverlayLoader } from "../PageLoading";
import { useTranslation } from "react-i18next";

export const DIALOG_ACTIONS = {
  CONFIRM: "CONFIRM",
  CANCEL: "CANCEL",
  RESET: "RESET",
};

export default function DupontDialog(props) {
  const { t } = useTranslation();
  const {
    open,
    onClose,
    title,
    customTitle,
    confirmBtnText,
    cancelBtnText,
    resetBtnText,
    customClass,
    confirmDisabled,
    restoreDisabled,
    type,
    subTitle,
    isOverlayLoader,
    showisRequired = false,
    maxWidth,
    minWidth,
    customHeight = "450px",
  } = props;

  // const cancelBtnText = props.cancelBtnText || t("ValueStrings.cancel");
  const btnColor = type === "primary" ? "white" : type;

  const closeBtnHandler = () => onClose(DIALOG_ACTIONS.CANCEL);
  const confirmBtnHandler = () => onClose(DIALOG_ACTIONS.CONFIRM);
  const resetBtnHandler = () => onClose(DIALOG_ACTIONS.RESET);

  const getDialogTheme = () => {
    const dialogType = type || "default";
    return `dupont-dialog--${dialogType}`;
  };
  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      event.stopPropagation();
    }
  };

  return (
    <Dialog
      onClose={closeBtnHandler}
      aria-labelledby={title}
      onKeyDown={handleKeyDown}
      open={open}
      maxWidth={maxWidth}
      disableBackdropClick={true}
      PaperProps={{
        style: {
          minWidth: minWidth,
        },
      }}
    >
      {isOverlayLoader && <OverlayLoader customHeight={customHeight} />}
      <div className={`dupont-dialog ${getDialogTheme()} ${customClass || ""}`}>
        <header>
          <div className="dupont-dialog__title"> {title}</div>
          {customTitle && <div>{customTitle}</div>}
          <div
            className="dupont-dialog__subTitle"
            dangerouslySetInnerHTML={{ __html: subTitle }}
          />
        </header>

        <main className={`dupont-dialog__body`}> {props.children} </main>
        <footer className="dupont-dialog__footer">
          {cancelBtnText && (
            <DupontButton
              id="cancelBtn"
              type={"secondary"}
              color={btnColor}
              onClick={closeBtnHandler}
              customClass="dupont-dialog__footer--btn-spacing"
            >
              {cancelBtnText}
            </DupontButton>
          )}
          {resetBtnText && (
            <DupontButton
              id="resetBtn"
              type={"secondary"}
              color={btnColor}
              disabled={restoreDisabled}
              onClick={resetBtnHandler}
              customClass="dupont-dialog__footer--reset-btn"
            >
              {resetBtnText}
            </DupontButton>
          )}
          {confirmBtnText && (
            <DupontButton
              id="submitBtn"
              type={"primary"}
              color={btnColor}
              disabled={confirmDisabled}
              onClick={confirmBtnHandler}
              customClass="dupont-dialog__footer--confirm-btn"
            >
              {confirmBtnText}
            </DupontButton>
          )}
        </footer>
      </div>
    </Dialog>
  );
}
